import { StackProps, Stack } from "@mui/material";
import { Form } from "formik";

export default function FormikForm(props: StackProps<typeof Form>) {
  return <Stack spacing={2} component={Form} {...props} />;
}
